<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    v-b-tooltip.hover.right
    class="nav-item d-block"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
    :title="isSidebarCollapsed ? item.title : ''"
  >
    <b-link
      :to="{name: linkProps.to ? linkProps.to.name : 'dashboard', params: { projectId: activeProjectId } }"
      target=""
      class="d-flex align-items-center"
      @click="handleNameMenuLinkClick(item.module)"
    >
      <GjIcon
        :name="item.gjIcon || 'Globe'"
      />
      <span
        v-if="!isSidebarCollapsed"
        class="menu-title text-truncate"
      >{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag && !isSidebarCollapsed"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto text-sm font-weight-regular"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeProjectId() {
      return this.$store.getters['projectModule/getActiveProjectId']
    },
    isSidebarCollapsed() {
      return this.$store.state.projectModule.isSidebarCollapsed && this.$store.state.app.windowWidth > 1199
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,
      // ACL
      canViewVerticalNavMenuLink,
      // i18n
      t,
    }
  },
  methods: {
    handleNameMenuLinkClick(module) {
      if (this.isActive && module) this.$store.commit(`${module}/RESET_FILTER`)
    },
  },

}
</script>
